export const REVENUE_CATEGORY_IDENTIFIER = "40000";
export const LIABILITY_CATEGORY_IDENTIFIER = "20000";
export const EXPENSE_CATEGORY_IDENTIFIER = "50000";
export const ASSET_CATEGORY_IDENTIFIER = "10000";
export const RETAINED_EARNING_IDENTIFIER = "31400";
export const BANK_CATEGORY_IDENTIFIER_PREFIX = "13";
export const FIXED_ASSET_CATEGORY_IDENTIFIER_PREFIX = "14";
export const FIXED_ASSET_IDENTIFIER = 14000;
export const DEPRECIATION_EXPENSE_IDENTIFIER = 53020;
export const ACCUMULATED_DEPRECIATION_IDENTIFIER = 14030;
export const INCOME_INDENTIFIER = 41000;
export const EXCHANGE_GAIN_OR_LOSS_IDENTIFIER = 53030;
export const WITHHELD_TAX_PAYABLE_IDENTIFIER = 23084;
export const OPERATING_EXPENSES_CATEGORY = "OPERATING_EXPENSES";
export const SALES_AND_PRODUCTS_CATEGORY = "PRODUCT_SALES_INCOME";
export const PREPAID_EXPENSES_CATEGORY_TAG = "Prepaid Expenses";
